import axios from "./axiosInstance";

const CalendarAPI = {
  // getCalendarInfo: (params) => axios.post(`/getTripsByMonth`, { params }),
  getCalendarInfo: (params) => axios.post(`/getTripsByMonth`, params),
  getTripCardInfo: (params) => axios.get(`/alltrips`, {params} ),
};

export default CalendarAPI;